import './App.css';
import { persistor, store } from './store/store';
import AppRouter from './routes/routes';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import React from 'react';

function App() {

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <AppRouter/>
      </PersistGate>
    </Provider>
    // <div className="flex flex-col">
    //   <div className="flex-grow h-full">
    //     <Rutas/>
    //   </div>
    // </div>
  );
}

export default App;
